function i(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
export {
  i as default
};
//# sourceMappingURL=assertThisInitialized.js.map
